import React from "react";
import TopHeader from "../../../components/TopHeader.tsx";
import resBlack from "./../../../assets/icons/bank.png";
import BankDetailsDeliveryMan from "./components/BankDetailsDeliveryMan.tsx";
import WidthdrawDetailDeliveryMan from "./components/WidthdrawDetailDeliveryMan.tsx";
// import BankDetails from "./componenets/BankDetails.tsx";
// import WidthdrawDetails from "./componenets/WidthdrawDetails.tsx";

const ManageDeliveryMan = () => {
  const [menuSelection, setMenuSelection] = React.useState(0);
  const changeMenu = (props) => {
    setMenuSelection(props);
  };
  return (
    <div>
      <TopHeader />
      <div className="d-flex kycScroll" style={{ overflow: "scroll" }}>
        <div className="d-flex" style={{ width: "107vw" }}>
          <div className="">
            {/* <div className="searchBoxForProduct" style={{ padding: "10px" }}>
              <input
                type="text"
                placeholder="Search"
                className="form-control searchBar"
              />
            </div> */}

            <div
              className="scrollable-div"
              style={{ width: "13rem", height: "100vh" }}
            >
              <h6 className=" ms-3 mt-2" style={{ fontSize: "13px" }}>
                <b> Delivery Man Settings</b>
              </h6>
              <hr className="" style={{ margin: ".5rem" }} />

              <div
                className={`manage_delivery_man__menuItem ${menuSelection === 0 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(0)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Bank Details
                  </p>
                </div>
              </div>

              <div
                className={`manage_delivery_man__menuItem ${menuSelection === 1 ? "active" : ""}`}
                style={{
                  width: "100%",
                  height: "3rem",
                  transition: "background-color 0.3s",
                }}
                onClick={() => changeMenu(1)}
              >
                <div
                  className=" d-flex justify-content-start align-items-center ms-3"
                  style={{ height: "100%", gap: "10px" }}
                >
                  <img
                    src={resBlack}
                    alt="leo"
                    style={{ width: "1.2rem", height: "1.2rem" }}
                  />
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                      marginBottom: "0px",
                      fontSize: "13px",
                    }}
                  >
                    Withdraw Requests
                  </p>
                </div>
              </div>
            </div>
          </div>
          {menuSelection === 0 ? (
            <>
              <BankDetailsDeliveryMan />
            </>
          ) : (
            <span></span>
          )}

          {menuSelection === 1 ? (
            <>
              <WidthdrawDetailDeliveryMan />
            </>
          ) : (
            <span></span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageDeliveryMan;
